<footer>
  <div class="footer-content">
    <img src="/LogoOttobre 2.png" alt="Eleonora Ceroni Psicologa Faenza" class="footer-image" />
    <div class="copyright">
      <p>&copy; 2025 Dr.ssa Eleonora Ceroni. P.IVA 02769980398. Tutti i diritti riservati.</p>
    </div>
  </div>
</footer>

<style>
  footer {
    background-color: white;
    color: var(--text-color);
    padding: 0.5rem 0; /* MODIFICATO: Ridotto il padding verticale per meno spazio */
    margin-top: 1rem;
  }
  .footer-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }
  .footer-image {
    width: 300px;
    height: 300px;
    object-fit: contain;
    margin-bottom: 0.5rem;	
  }
  .copyright {
    text-align: center;
    font-size: 0.9rem; /* MODIFICATO: Aumentata la dimensione del font */
    margin-bottom: 0.5rem;
  }
  .copyright p {
    margin: 0;
  }
  @media (max-width: 768px) {
    footer {
      padding: 0.5rem 0; /* MODIFICATO: Ridotto anche qui per coerenza */
    }
    .footer-image {
      width: 180px;
      height: 180px;
    }
    .copyright {
      font-size: 0.7rem; /* MODIFICATO: Aumentata la dimensione anche su mobile */
    }
  }
</style>